import { format } from "date-fns";
import { Button, Text } from "../UI";
import { useMobile } from "../utils/mobile";
import Checkbox from "../UI/Checkbox/Checkbox";
import plus from "../asserts/img/plus.svg";
import { useTranslation } from "react-i18next";
import { isUrl } from "../utils/helper";

export const Item = ({ value, label, width, valueColor, labelColor }) => {
  const isMobile = useMobile();
  
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        flexBasis: width,
        padding: 5,
        gap: 5,
        paddingInlineEnd: 20,
      }}>
      <Text
        style={{
          fontSize: 13,
          fontWeight: 500,
          color: labelColor || "#9FA2B4",
          width: "auto",
          textAlign: "start"
        }}>
        {label}
      </Text>
      {isUrl(value) ? (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: valueColor || "#293041",
            fontSize: 14,
            fontWeight: 400,
            textDecoration: "none",
            overflow: "hidden",
            whiteSpace: isMobile ? "wrap" : "nowrap",
            textOverflow: "ellipsis",
            textAlign: "start",
            maxWidth: "auto",
          }}>
          {value}
        </a>
      ) : (
        <Text
          style={{
            color: valueColor || "#293041",
            fontSize: 14,
            fontWeight: 400,
            overflow: "hidden",
            whiteSpace: isMobile ? "wrap" : "nowrap",
            textOverflow: "ellipsis",
            textAlign: "start",
            maxWidth: "auto",
          }}>
          {value || "-"}
        </Text>
      )}
    </div>
  );
};

// Parses a date value using the calendar day encoded in the value itself,
// independent of the viewer's local timezone. Priority returns report dates
// like "2026-07-20T00:00:00+03:00"; parsing that through the browser's local
// timezone (as new Date() does) can shift the day by one for viewers at a
// lower offset. We read the Y/M/D straight from the ISO string instead.
// Returns null for empty or invalid values.
export const parseDateOnly = (value) => {
  if (!value) return null;

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  const date = match
    ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
    : new Date(value);

  if (isNaN(date.getTime())) return null;

  return date;
};

// Formats a date value using the same timezone-independent parsing as
// parseDateOnly.
export const formatDateOnly = (value, pattern = "dd/MM/yy") => {
  const date = parseDateOnly(value);
  if (!date) return "-";

  return format(date, pattern);
};

export const renderKeyValue = (key, selecteRow) => {
  if (selecteRow[key.key] === null) {
    return "-";
  } else if (key.key?.includes("DATE")) {
    return formatDateOnly(selecteRow[key.key]);
  } else if (key.key?.includes("ZCOR_TASK")) {
    return selecteRow["ZCOR_TASKNAME"];
  } else if (key.key?.includes("DOCNO")) {
    return selecteRow["DOCNO"];
  } else if (key.key?.includes("NO_CHARGE")) {
    return (
      <Checkbox
        id={selecteRow["TASKNAME"] || selecteRow["REPNO"]}
        key={selecteRow["TASKNAME"] || selecteRow["REPNO"]}
        inline={true}
        style={{ margin: "auto" }}
        checked={
          selecteRow["FREEOFCHARGE"] === "Y" ||
          selecteRow["NOCHARGEFLAG"] === "Y"
        }
        width="23px"
        disabled="true"
        height="23px"></Checkbox>
    );
  } else if (key.key?.includes("PROJECT_DEV")) {
    return (
      <Checkbox
        inline={true}
        style={{ margin: "auto" }}
        checked={selecteRow["PROJECTDEV"] === "Y"}
        width="23px"
        disabled="true"
        height="23px"></Checkbox>
    );
  } else if (isUrl(selecteRow[key.key])) {
    return (
      <a
        href={selecteRow[key.key]}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#007BFF",
          textDecoration: "none",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}>
        {selecteRow[key.key]}
      </a>
    );
  } else {
    return selecteRow[key.key];
  }
};

// Shown instead of a blank area when a list has nothing to display
export const EmptyListMessage = ({ text }) => (
  <Text style={{ display: "block", padding: "40px 20px", textAlign: "center", color: "#9FA2B4" }}>
    {text}
  </Text>
);

export const MobileAddButton = ({ handelOpenNewClick }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  return (
    <div
      style={{
        marginTop: "1em",
        display: "flex",
        justifyContent: "end",
        position: "absolute",
        left: isRtl && 20,
        right: !isRtl && 20,
        bottom: 20,
      }}>
      <Button
        style={{
          borderRadius: "30px",
          width: 58,
          height: 58,
          // Standard floating-button elevation, so it reads as floating above the list
          boxShadow:
            "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12)",
        }}
        onClick={handelOpenNewClick}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}>
          <img src={plus} alt="add" />
        </div>
      </Button>
    </div>
  );
};
